import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { Directive, forwardRef, Input } from '@angular/core';

@Directive({
    selector: '[max][formControlName],[max][formControl],[max][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MaxValidatorDirective),
            multi: true,
        },
    ],
})
export class MaxValidatorDirective implements Validator {
    @Input()
    max: number;

    validate(control: AbstractControl): { [key: string]: any } {
        return Validators.max(this.max)(control);
    }
}
